const DESKTOP_TABLET = window.matchMedia("(min-width: 768px)");
const SPLITTING_SELECTORS = [
  "h2,h3,p,.section__footer-link-small,.section__footer-heading,.section__footer-link-big,.w-richtext li",
];
const COUNT_ELEMENTS = [
  ".elem__card-product--wrap,.elem__card-feature--slide,.elem__card-thumb--wrap",
];
const PAGE_FLIP_NEXT_SELECTOR = '[data-pf-page="next"]';
const PAGE_FLIP_ITEM_SELECTOR = '[data-pf="item"]';
const PAGE_FLIP_START_DELAY = 500;

function countElements(selectors) {
  selectors.forEach((selector) => {
    const parents = new Set(
      Array.from(document.querySelectorAll(selector))
        .map((element) => element.parentElement)
        .filter(Boolean)
    );

    parents.forEach((parent) => {
      let count = 0;
      let previousTop = 0;

      Array.from(parent.children)
        .filter((child) => child.matches(selector))
        .forEach((element, index) => {
          const top = element.getBoundingClientRect().top;
          if (index > 0 && top - previousTop > 7) count = 0;
          element.style.setProperty("--index", count++);
          element.classList.add("animate");
          previousTop = top;
        });
    });
  });
}

function applySplitting() {
  if (!DESKTOP_TABLET.matches || !window.Splitting) return;

  SPLITTING_SELECTORS.forEach((selector) => {
    document.querySelectorAll(selector).forEach((element) => {
      if (element.dataset.splittingOriginal === undefined) {
        element.dataset.splittingOriginal = element.innerHTML;
      } else {
        element.innerHTML = element.dataset.splittingOriginal;
      }

      window.Splitting({ target: element, by: "chars" });
    });
  });

  countElements(COUNT_ELEMENTS);
}

function restoreAboveFoldReveals() {
  const cutoff = window.scrollY + window.innerHeight;

  document.querySelectorAll(".char, .gsap_split_letter").forEach((element) => {
    const absoluteTop = element.getBoundingClientRect().top + window.scrollY;
    if (absoluteTop >= cutoff) return;

    const styles = window.getComputedStyle(element);
    if (styles.opacity === "0" || styles.visibility === "hidden") {
      element.style.opacity = "1";
      element.style.visibility = "visible";
    }
  });
}

function startInViewReveals() {
  document.querySelectorAll(".animate:not(.start)").forEach((element) => {
    if (element.getBoundingClientRect().top < window.innerHeight) {
      element.classList.add("start");
    }
  });
}

function initTabs() {
  document.querySelectorAll(".content__tabs-nav").forEach((tab) => {
    if (tab.dataset.tabInit === "true") return;

    tab.dataset.tabInit = "true";
    tab.addEventListener("click", () => {
      const href = tab.querySelector("[href]")?.getAttribute("href");
      if (!href) return;

      const target = document.querySelector(href);
      if (!target) return;

      target.querySelectorAll(".animate").forEach((element) => {
        window.setTimeout(() => {
          element.classList.add("start");
        }, 500);
      });
    });
  });
}

function isVisiblePageItem(item) {
  if (!item) return false;

  const styles = window.getComputedStyle(item);
  if (styles.display === "none" || styles.visibility === "hidden") return false;

  return item.getClientRects().length > 0;
}

function getVisiblePageItems() {
  return Array.from(document.querySelectorAll(PAGE_FLIP_ITEM_SELECTOR)).filter(isVisiblePageItem);
}

function initPageFlipStartAnimation() {
  document.addEventListener(
    "click",
    (event) => {
      const nextButton = event.target.closest(PAGE_FLIP_NEXT_SELECTOR);
      if (!nextButton) return;

      const visibleItemsBeforeClick = new Set(getVisiblePageItems());

      window.setTimeout(() => {
        getVisiblePageItems().forEach((item) => {
          if (!visibleItemsBeforeClick.has(item)) {
            item.classList.add("start");
          }
        });
      }, PAGE_FLIP_START_DELAY);
    },
    true
  );
}

function emitWebflowSecondLoad() {
  try {
    const webflowInteractions = window.Webflow?.require?.("ix3");
    if (typeof webflowInteractions?.emit === "function") {
      webflowInteractions.emit("second-load");
    }
  } catch (error) {
    return;
  }
}

function initResizeRecovery() {
  let resizeTimer;
  let lastWidth = window.innerWidth;
  let lastHeight = window.innerHeight;

  window.addEventListener(
    "resize",
    () => {
      clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        const widthChange = Math.abs(window.innerWidth - lastWidth);
        const heightChange = Math.abs(window.innerHeight - lastHeight);
        lastWidth = window.innerWidth;
        lastHeight = window.innerHeight;

        if (widthChange < 8 && heightChange < 8) return;

        applySplitting();
        startInViewReveals();
        emitWebflowSecondLoad();

        if (window.ScrollTrigger) {
          window.ScrollTrigger.refresh();
        }

        window.setTimeout(restoreAboveFoldReveals, 200);
      }, 250);
    },
    { passive: true }
  );
}

function initTextAnimations() {
  applySplitting();
  startInViewReveals();
  initTabs();
  initPageFlipStartAnimation();
  initResizeRecovery();

  const handleBreakpointChange = () => {
    applySplitting();
    startInViewReveals();
    initTabs();
  };

  if (DESKTOP_TABLET.addEventListener) {
    DESKTOP_TABLET.addEventListener("change", handleBreakpointChange);
  } else if (DESKTOP_TABLET.addListener) {
    DESKTOP_TABLET.addListener(handleBreakpointChange);
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initTextAnimations);
} else {
  initTextAnimations();
}
